<form #citizenshipFormElement [formGroup]="citizenshipForm">
  <div class="row">
    <section class="data-field col-xl-4">
      <div class="label">
        <span [innerHTML]="'citizenship' | translate | safe: 'html'"></span>
      </div>

      <mat-form-field [floatLabel]="'always'" appearance="outline" class="select">
        <mat-select (selectionChange)="updateUser()" formControlName="citizenship"
                    name="citizenship">
          <mat-select-trigger>
              <span *ngIf="getCountryCode(citizenshipModel.citizenship)" class="ml-auto">
<!--                <img src="/img/flags/{{getCountryCode(citizenshipModel.citizenship)}}.png"-->
                <!--                     [default]="'/img/flags/undefined.png'" class="small-flag-icon">-->
              </span>
            <span class="country-info"> {{ getTranslate(citizenshipModel.citizenship) }}</span>
          </mat-select-trigger>
          <mat-select-search #citizenshipSearch></mat-select-search>
          <mat-option *ngFor=" let country of filterCountryList(countryList, citizenshipSearch.filter, false)"
                      value="{{country.countryName}}">
            <!--            <img src="/img/flags/{{country.countryCode}}.png" [default]="'/img/flags/undefined.png'"-->
            <!--                 class="flag-icon">-->
            <span class="country-info">{{ country.countryTranslation }}</span>
          </mat-option>
        </mat-select>
        <mat-error *ngIf="isRequiredField('citizenship')">
          <p [translate]="'citizenshipRequired'">Citizenship is required</p>
        </mat-error>
      </mat-form-field>
    </section>

    <section class="data-field col-xl-4">
      <div class="label">
        <span [innerHTML]="'countryOfBirth' | translate | safe: 'html'"></span>
      </div>

      <mat-form-field [floatLabel]="'always'" appearance="outline" class="select">
        <mat-select (selectionChange)="updateUser()" disableOptionCentering
                    formControlName="countryOfBirth" name="countryOfBirth">
          <mat-select-trigger>
              <span *ngIf="getCountryCode(citizenshipModel.countryOfBirth)" class="ml-auto">
<!--                <img src="/img/flags/{{getCountryCode(citizenshipModel.countryOfBirth)}}.png"-->
                <!--                     [default]="'/img/flags/undefined.png'" class="small-flag-icon">-->
              </span>
            <span class="country-info"> {{ getTranslate(citizenshipModel.countryOfBirth) }}</span>
          </mat-select-trigger>
          <mat-select-search #countryOfBirthSearch></mat-select-search>
          <mat-option *ngFor=" let country of filterCountryList(countryList, countryOfBirthSearch.filter, false)"
                      value="{{country.countryName}}">
            <!--            <img src="/img/flags/{{country.countryCode}}.png" [default]="'/img/flags/undefined.png'"-->
            <!--                 class="flag-icon">-->
            <span class="country-info">{{ country.countryTranslation }}</span>
          </mat-option>
        </mat-select>
        <mat-error *ngIf="isRequiredField('countryOfBirth')">
          <p [translate]="'countryOfBirthRequired'"></p>
        </mat-error>
      </mat-form-field>
    </section>

    <section class="data-field col-xl-4">
      <div class="label">
        <span [innerHTML]="'passport' | translate | safe: 'html'"></span>
      </div>

      <mat-form-field [floatLabel]="'always'" appearance="outline" subscriptSizing="dynamic">
        <input (change)="updateUser()" formControlName="idNumber" matInput
               name="passport" oninput="this.value=this.value.replace(/[^A-Za-z0-9_-]/g,'')">

        <mat-error *ngIf="isRequiredField('idNumber')">
          <p [translate]="'passportRequired'"></p>
        </mat-error>

        <mat-error *ngIf="hasErrorField('idNumber', 'minlength')">
          <p [translate]="'passportMinLength'"></p>
        </mat-error>

        <mat-error *ngIf="hasErrorField('idNumber', 'forbidden')">
          <p [translate]="'ForbiddenPassport'"></p>
        </mat-error>
      </mat-form-field>
    </section>

    <section class="data-field col-xl-4">
      <div class="label">
        <span [innerHTML]="'countryIssuence' | translate | safe: 'html'"></span>
      </div>

      <mat-form-field [floatLabel]="'always'" appearance="outline" class="select">
        <mat-select (selectionChange)="updateUser()"
                    disableOptionCentering formControlName="countryIssuence"
                    name="countryIssuence">
          <mat-select-trigger>
              <span *ngIf="getCountryCode(citizenshipModel.countryIssuence)" class="ml-auto">
<!--                <img src="/img/flags/{{getCountryCode(citizenshipModel.countryIssuence)}}.png"-->
                <!--                     [default]="'/img/flags/undefined.png'" class="small-flag-icon">-->
              </span>
            <span class="country-info"> {{ getTranslate(citizenshipModel.countryIssuence) }}</span>
          </mat-select-trigger>
          <mat-select-search #countryIssuenceSearch></mat-select-search>
          <mat-option *ngFor=" let country of filterCountryList(countryList, countryIssuenceSearch.filter)"
                      value="{{country.countryName}}">
            <!--            <img src="/img/flags/{{country.countryCode}}.png" [default]="'/img/flags/undefined.png'"-->
            <!--                 class="flag-icon">-->
            <span class="country-info">{{ country.countryTranslation }}</span>
          </mat-option>
        </mat-select>
        <mat-error *ngIf="isRequiredField('countryIssuence')">
          <p [translate]="'countryIssuenceRequired'"></p>
        </mat-error>

      </mat-form-field>
    </section>
  </div>
</form>
